import { useEffect } from 'react';
import { useNavigate, type NavigateFunction } from 'react-router-dom';
import { useRoutes } from 'react-router-dom';
import routes from './config';

// Extend the Window interface to include REACT_APP_NAVIGATE
declare global {
  interface Window {
    REACT_APP_NAVIGATE: NavigateFunction;
  }
}

let navigateResolver: (navigate: ReturnType<typeof useNavigate>) => void;

export const navigatePromise = new Promise<NavigateFunction>((resolve) => {
  navigateResolver = resolve;
});

export function AppRoutes() {
  const element = useRoutes(routes);
  const navigate = useNavigate();
  
  // Only set navigate once
  useEffect(() => {
    window.REACT_APP_NAVIGATE = navigate;
    navigateResolver(navigate);
  }, [navigate]);
  
  return element;
}
